import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";

const Config = ({ files, config, onConfigChange }) => {
  const [recommendedFirmware, setRecommendedFirmware] = useState(
    config?.recommended_firmware_version || ""
  );
  const [changed, setChanged] = useState(false);
  const [alert, setAlert] = useState(null);
  const [showEasterEgg, setShowEasterEgg] = useState(false);

  useEffect(() => {
    setRecommendedFirmware(config?.recommended_firmware_version);
  }, [config]);

  const handleEasterEgg = () => {
    setShowEasterEgg(true);
    setTimeout(() => setShowEasterEgg(false), 2000);
  };

  const handleFirmwareVersionChange = (e) => {
    setRecommendedFirmware(e.target.value);
    if (e.target.value !== config?.recommended_firmware_version) {
      setChanged(true);
    } else {
      setChanged(false);
    }
  };

  const handleFirmwareVersionSubmit = (e) => {
    e.preventDefault();
    let formBody = [];
    formBody.push(
      encodeURIComponent("value") +
        "=" +
        encodeURIComponent(recommendedFirmware)
    );
    formBody = formBody.join("&");

    fetch(
      `${process.env.REACT_APP_API_URL}/config/recommended_firmware_version?${formBody}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setChanged(false);
            setAlert({
              type: "success",
              message: "Firmware version updated successfully",
            });
            onConfigChange(data);
          });
        }
      })
      .catch((error) => {
        console.log(error);
        setAlert({
          type: "danger",
          message: "Error updating firmware version",
        });
      });
  };

  return (
    <>
      {showEasterEgg && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "200px",
            animation: "fadeInOut 2s ease-in-out",
            zIndex: 1000,
          }}
        >
          🖕🏿
        </div>
      )}
      <style>
        {`
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translate(-50%, -50%) scale(0.5); }
            20% { opacity: 1; transform: translate(-50%, -50%) scale(1.2); }
            80% { opacity: 1; transform: translate(-50%, -50%) scale(1.2); }
            100% { opacity: 0; transform: translate(-50%, -50%) scale(0.5); }
          }
        `}
      </style>
      <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "25px"}}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          <img
            src="/rkl-logo-nobkg.png"
            alt="Logo"
            style={{ width: "150px", marginLeft: "25px", cursor: "pointer" }}
            onClick={handleEasterEgg}
          />
          <h3 style={{ marginLeft: "25px" }}>Megazord OTA Server</h3>
        </Col>

        <Col>
          {alert && (
            <Alert variant={alert.type} onClose={() => setAlert(null)} dismissible>
              {alert.message}
            </Alert>
          )}
        </Col>
        <Col
          xs={{ span: 3, offset: 1 }}
          style={{
            backgroundColor: "rgb(0,0,0,0.2)",
            padding: "20px",
            borderRadius: "0 0 0 20px",
          }}
        >
          <Row>
            <h3>Config</h3>
          </Row>
          <Row>
            <Form>
              <Row>
                    <Form.Label>Recommended Firmware:</Form.Label>
                <Col>
                  <Form.Group className="mb-3" controlId="recommendedFirmware">
                    <Form.Select
                      aria-label="Select recommended firmware"
                      value={recommendedFirmware}
                      onChange={handleFirmwareVersionChange}
                    >
                      <option disabled value="">
                        Select firmware
                      </option>
                      {files.map((file) => (
                        <option key={file.version} value={file.version}>
                          {file.version}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
            {changed && (
              <Button
                variant="primary"
                type="submit"
                onClick={handleFirmwareVersionSubmit}
              >
                Submit
              </Button>
            )}
                </Col>
              </Row>
            </Form>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Config;
